// 候補者向けの採用ポータル (/candidate) のページの一覧。トップのカードとサイドバーのメニューが
// 同じ名前を使う（ページ名の SSOT）。

export const candidateSections = [
  {
    title: { ja: "CEOメッセージ", en: "Message from the CEO" },
    path: "/candidate/message",
    body: {
      ja: "CEOから候補者の方へ。GenerativeXがいま取りに行く市場と、入社する意味。",
      en: "A message from our CEO to candidates — the market GenerativeX is pursuing now, and what joining means.",
    },
  },
  {
    title: { ja: "会社紹介", en: "About the Company" },
    path: "/candidate/company",
    body: {
      ja: "会社基本情報、事業、組織、オフィス。",
      en: "Company overview, business, organization, and office.",
    },
  },
  {
    title: { ja: "事業内容・事例", en: "Business & Case Studies" },
    path: "/candidate/cases",
    body: {
      ja: "3 つの事業と、入社後に携わるプロジェクトのイメージ。業界別の導入事例とエージェントの実例。",
      en: "Our three businesses and the projects you'll work on after joining — industry case studies and real agent examples.",
    },
  },
  {
    title: { ja: "開発について", en: "How We Build" },
    path: "/candidate/development",
    body: {
      ja: "全員がコードを書く開発スタイル。AIツール、共通テンプレート、職種別の関わり方。",
      en: "A development style where everyone writes code — AI tooling, a shared template, and how each role gets involved.",
    },
  },
  {
    title: { ja: "よくある質問", en: "FAQ" },
    path: "/candidate/faq",
    body: {
      ja: "候補者の方からよくいただく質問と回答。",
      en: "Questions candidates often ask, with our answers.",
    },
  },
  {
    title: { ja: "メディア・動画", en: "Media & Videos" },
    path: "/candidate/media",
    body: {
      ja: "面接の前にご覧いただく動画、記事、ニュース、社員インタビュー。",
      en: "Pre-interview videos, articles, news, and employee interviews.",
    },
  },
  {
    title: { ja: "選考・待遇", en: "Selection & Compensation" },
    path: "/candidate/process",
    body: {
      ja: "選考の流れ、面接当日のご案内、報酬、SO。",
      en: "Selection flow, interview-day guide, compensation, and stock options.",
    },
  },
  {
    title: { ja: "募集ポジション", en: "Open Positions" },
    path: "/candidate/jobs",
    body: {
      ja: "いま募集しているポジションと、このサイトからの応募。",
      en: "Positions we are hiring for now, and how to apply from this site.",
    },
  },
  {
    title: { ja: "1日のスケジュール", en: "A Day in the Life" },
    path: "/candidate/schedule",
    body: {
      ja: "出社前提・社内会議ゼロの働き方。コンサルタントとエンジニア、それぞれの1日。",
      en: "Office-based, zero internal meetings. A typical day for consultants and engineers.",
    },
  },
  {
    title: { ja: "キャリアパス・評価", en: "Career Path & Evaluation" },
    path: "/candidate/career",
    body: {
      ja: "3フェーズの成長モデル、専門化の4方向、評価の3軸。GenerativeX でのキャリアの全体像。",
      en: "Three growth phases, four specialization directions, and three evaluation axes — the full picture of a career at GenerativeX.",
    },
  },
  {
    title: { ja: "数字で見るGenerativeX", en: "GenerativeX by the Numbers" },
    path: "/candidate/numbers",
    body: {
      ja: "社内会議ゼロ・Dreamforce登壇など、数字で見るGenerativeXの実像。",
      en: "Zero internal meetings, a Dreamforce stage and more — GenerativeX in numbers.",
    },
  },
] as const;

/** 「開発について」の下のページ。サイドバーでは開発についての下に畳んで並べる。 */
export const developmentPages = [
  { title: { ja: "共通", en: "Overview" }, path: "/candidate/development", exact: true },
  {
    title: { ja: "コンサルタント向け", en: "For consultants" },
    path: "/candidate/development/consultant",
  },
  {
    title: { ja: "エンジニア向け", en: "For engineers" },
    path: "/candidate/development/engineer",
    exact: true,
  },
  {
    title: { ja: "実装事例", en: "Implementation cases" },
    path: "/candidate/development/engineer/cases",
    deeper: true,
  },
] as const;
